/** The server's `uiType` values, which select the question's input control. */
export const INDIVIDUAL_UI_TYPE = 'Individual';
export const DAYS_AND_HOURS_UI_TYPE = 'Days And Hours';

/** Where the survey was started, sent with its tracking and submission. */
export enum WellbeingMeasureEntryPoint {
  HomeTodo = 'home_todo',
  DirectLink = 'direct_link',
}
